import {
  ArticuloStyle,
  LinkTitle,
  LinkTitleDiv,
  Ratings,
  ThumbImage,
} from "./faqElements";
import thumbsUp from "../svg/thumbs-up.png";
import thumbsDown from "../svg/thumbs-down.png";
import TranslatableText from "../Multilanguage/TranslatableText";

export const Articulo = (props) => {
  const { faq } = props;

  return (
    <ArticuloStyle to={`/faq/${faq.faqID}`} key={faq.faqID}>
      <LinkTitleDiv>
        {/* <LinkTitle>{faq.question}</LinkTitle> */}
        <LinkTitle>{<TranslatableText text={faq.question} />}</LinkTitle>
      </LinkTitleDiv>
      <Ratings>
        <div className="flex flex-col items-center justify-start">
          <ThumbImage src={thumbsUp} alt="thumbs up" />          
          <p style={{ color: "gray" }}>{faq.yesCount}</p>
        </div>
        <div className="flex flex-col items-center justify-start">
          <ThumbImage src={thumbsDown} alt="thumbs down" />          
          <p style={{ color: "gray" }}>{faq.noCount}</p>
        </div>
      </Ratings>
    </ArticuloStyle>
  );
};
